import React, { useEffect, useState } from "react";
import { TreeSelect } from "antd";
import { getChildUserOrgDetails } from "services/assetRecoveryService";

interface OrgUnit {
  uu_id: string;
  unit_name: string;
  children: OrgUnit[];
}

interface TreeNode {
  title: string;
  value: string;
  children?: TreeNode[];
}

interface OrgUnitTreeSelectProps {
  value?: string;
  onChange: (value: string) => void;
  adminUnitId: string;
  orgUnitId: string;
}

const OrgUnitTreeSelect: React.FC<OrgUnitTreeSelectProps> = ({
  value,
  onChange,
  adminUnitId,
  orgUnitId,
}) => {
  const [treeData, setTreeData] = useState<TreeNode[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!adminUnitId || !orgUnitId) return;
    const fetchOrgUnits = async () => {
      setLoading(true);
      try {
        const  data  = await getChildUserOrgDetails(adminUnitId, orgUnitId);

        const root = data.child_org_units?.tree;
        const mapped = root ? [mapToTreeNode(root)] : [];
        setTreeData(mapped);
      } catch (err) {
        console.error("Failed to fetch org units", err);
      } finally {
        setLoading(false);
      }
    };

    fetchOrgUnits();
  }, [adminUnitId, orgUnitId]);

  const mapToTreeNode = (node: OrgUnit): TreeNode => ({
    title: node.unit_name,
    value: node.uu_id,
    children: node.children?.map(mapToTreeNode) || [],
  });

  return (
    <div className="w-full">
      {/* {loading ? (
        <Spin />
      ) : ( */}
        <TreeSelect
          style={{ width: "100%" ,color:'black'}}
          className="referral-form-field"
          value={value}
        //   dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
          treeData={treeData}
          placeholder="Select org unit to forward"
          onChange={onChange}
          treeDefaultExpandAll
          allowClear
        
        />
      {/* )} */}
    </div>
  );
};

export default OrgUnitTreeSelect;
